import Scrollable from "components/common/ui/Scrollable/Scrollable";
import Skeleton from "components/common/ui/Skeleton/Skeleton";
import { FunctionComponent, useEffect, useState } from "react";
import { ProductVariant } from "ts/types";
import Variant from "./ProductVariant/ProductVariant";
import { VariantsList, VariantsWrapper } from "./ProductVariants.Styled";
import { getSortKeyFromLabel } from "components/pdp/PdpDetails/PdpSizeActions/PdpSizeGuide/Measurement/UnitsOfMeasure";

interface ProductVariantsProps {
  variants: ProductVariant[];
  onChange?: (variant: ProductVariant) => void;
  defaultValue?: ProductVariant;
  className?: string;
  outOfStockSelectable?: boolean;
  loading?: boolean;
  controlled?: boolean;
  groupId?: string | undefined;
}

const ProductVariants: FunctionComponent<ProductVariantsProps> = ({
  variants = [],
  onChange,
  defaultValue = undefined,
  className = "",
  outOfStockSelectable = false,
  loading = false,
  controlled = false,
  groupId,
}) => {
  const [selectedVariant, setSelectedVariant] = useState<ProductVariant>(
    defaultValue as ProductVariant,
  );

  useEffect(() => {
    if (controlled && selectedVariant !== defaultValue) {
      setSelectedVariant(defaultValue as ProductVariant);
    }
  }, [defaultValue]);

  const onVariantClick = (variant: ProductVariant) => {
    !controlled && setSelectedVariant(variant);

    if (onChange) {
      onChange(variant);
    }
  };

  const sortedVariants = [...variants]
    .filter((variant) => variant.option !== undefined)
    .sort((a, b) => {
      const aKey = getSortKeyFromLabel(a.option.label, groupId);
      const bKey = getSortKeyFromLabel(b.option.label, groupId);
      return aKey - bKey;
    });

  if (loading) {
    return (
      <VariantsWrapper className={`loading ${className}`}>
        <Scrollable>
          <VariantsList className="VariantsList">
            {[...Array(5)].map((_, index) => (
              <li key={`variant-skeleton-${index}`}>
                <Skeleton width={40} height={40} />
              </li>
            ))}
          </VariantsList>
        </Scrollable>
      </VariantsWrapper>
    );
  }

  return (
    <VariantsWrapper className={`${className}`}>
      <Scrollable>
        <VariantsList className="VariantsList">
          {sortedVariants.map((variant) => {
            let value = variant.option.label;

            if (
              variant.option.displayName === "771" ||
              variant.option.displayName === "641"
            ) {
              value = String(Number(variant.option.label) / 10);
            }

            return (
              <Variant
                key={variant.sku}
                value={value}
                active={selectedVariant === variant}
                onClick={() => onVariantClick(variant)}
                available={
                  outOfStockSelectable
                    ? true
                    : variant.isPurchasable && variant.inventory.isInStock
                }
                hasStock={variant.isPurchasable && variant.inventory.isInStock}
                groupId={groupId}
              />
            );
          })}
        </VariantsList>
      </Scrollable>
    </VariantsWrapper>
  );
};

export default ProductVariants;
